import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './currentevalsall.css';
import useQCEStore from '../../store/qce.store';
import Table from '../Table';
import { Empty, Card } from "antd";

export default function CurrentEvalsAll() {
    const navigate = useNavigate();
    const { getAllEvalCategory, allEvalCategory } = useQCEStore();
    const titleList = ['Sr no.', 'JD ID', 'Eval ID', 'Category', 'Skills', 'Status', 'Application Count'];

  const evalData = allEvalCategory?.map((item, idx) => {
    return {
      id: idx + 1,
      title: item.qhcompanyjid, //name as per interface
      evid: item.qhjdevid,
      category: item.category || "--",
      skills:
        item.skillarray
          ?.map((s) => {
            const skill = s.skill?.trim() || "";
            return skill.charAt(0).toUpperCase() + skill.slice(1);
          })
          .join(", ") || "--",
      status: item.state || "--",
      appcount: item.applicationcount || "0",
    };
  });

  const handleEvalClick = (EvalData) => {
    //not clean way to get job id from eval page
    navigate(`/jds/${EvalData.title}`, {
      state: { newView: "eval", qhevid: EvalData.evid },
    });
  };

  useEffect(() => {
    getAllEvalCategory();
  }, []);

  return (
    <div className="jds-wrapper">
      <h5 className="current-eval-heading">
        Current Evaluations ({evalData?.length})
      </h5>
      {evalData?.length > 0 ? (
        <div className="eval-grid">
          {evalData.map((item, idx) => {
            return (
              <Card
                key={item.id || idx}
                hoverable
                style={{
                  height: 150,
                  borderColor:
                    item.status.toLowerCase() === "live" ? "#52c41a" : "", // Your hex code here
                }}
                styles={{ body: { height: "100%" } }}
                onClick={() => handleEvalClick(item)}
              >
                <div className="card-section">
                  <div className="card-section-top">
                    <div className="title-top">
                      <div className="title-skills">{item.skills}</div>
                      <div className="Jid">{item.title}</div>
                    </div>
                    <div className="sub-title">{item.evid}</div>
                  </div>
                  <div className="card-section-bottom">
                    <div className="content">
                      <div className="application-count">
                        {item.appcount} Applications
                      </div>
                      <div className="status">
                        {/* The Status Dot */}
                        <span
                          className="status-dot"
                          style={{
                            backgroundColor:
                              item.status.toLowerCase() === "live"
                                ? "#52c41a"
                                : "#bfbfbf",
                          }}
                        ></span>

                        {/* The Status Text */}
                        <span
                          style={{
                            color:
                              item.status.toLowerCase() === "offline"
                                ? "grey"
                                : "inherit",
                          }}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
    </div>
  );
}